import { Component } from '@angular/core';

@Component({
  selector: 'app-choose-us',
  templateUrl: './choose-us.component.html',
  styleUrls: ['./choose-us.component.scss']
})
export class ChooseUsComponent {
  readonly reasons = [
    {
      title: '更贴近真实生产流程',
      description: '不是单独堆功能，而是围绕试用、部署、输出、协作和后续维护去设计完整体验。'
    },
    {
      title: '产品线方向清晰',
      description: '青华、丹书、丰芒分别面向不同场景，产品边界清楚，便于理解、评估与接入。'
    },
    {
      title: '响应和支持更直接',
      description: '重视问题排查和实际场景沟通，尽量减少客户在试用和落地阶段的沟通成本。'
    }
  ];

  readonly comparisonItems = [
    {
      title: '理解成本',
      ours: '通过清晰页面结构和产品分层，快速判断哪个产品更适合当前业务。',
      others: '信息零散、产品边界模糊，需要反复咨询才能建立完整认知。'
    },
    {
      title: '试用与评估',
      ours: '能较快进入试用沟通与需求对接，减少前期推进阻力。',
      others: '流程不清楚，试用入口与后续支持链路容易断开。'
    },
    {
      title: '长期合作',
      ours: '更关注持续迭代、版本升级、问题追踪和长期交付体验。',
      others: '偏一次性交付，后续支持与产品延续性不足。'
    }
  ];

  readonly pillars = [
    '以产品能力为核心，而不是仅靠营销叙述',
    '重视部署后的可用性、稳定性和后续维护',
    '页面信息结构尽量清晰，帮助用户快速做判断',
    '在企业沟通中更注重效率、透明度和持续协作'
  ];
}
